// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:16
import { ResourceTypeManagerData_abstract } from './../abstract/SagaSchema/ResourceTypeManagerData_abstract';
export class ResourceTypeManagerData extends ResourceTypeManagerData_abstract {}
